// extracted by mini-css-extract-plugin
export default {"azureFileContainer":"Azure_azureFileContainer__RP1ML","title":"Azure_title__GBSCV","label":"Azure_label__JMw3d","loadingPDF":"Azure_loadingPDF__VM0Fs"};